<script>
import Boleto from "./Boleto";
import FAQ from "./FAQ";
import moment from "@/utils/moment";
import API from "@/api";
import orderMixin from "@/mixins/orderMixin";
import support from "@/utils/support";
import Loader from "@/components/_base/Loader";

export default {
  mixins: [orderMixin],
  props: {
    payable: {
      type: Object,
      required: true
    }
  },
  components: {
    Boleto,
    FAQ,
    Loader
  },
  data() {
    return {
      boleto: null,
      loading: false,
      error: false,
      success: false
    };
  },
  methods: {
    getBoleto() {
      return this.payable.payments.find(
        payment =>
          payment.status === "waiting" &&
          payment.funding_instrument.type === "boletos"
      );
    },

    singularPayableType() {
      return this.payable.type.slice(0, -1);
    },

    buttonText() {
      return this.payable.type === "orders"
        ? "Ver mais detalhes da limpeza"
        : "Ver assinatura";
    },

    openSupport() {
      support.sendProofOfPayment();
    },

    async requestSubscription(frequency) {
      try {
        this.error = false;
        this.loading = true;

        await API.Subscriptions.requestSubscription(this.payable, frequency);

        this.loading = false;
        this.success = true;
      } catch (e) {
        this.error = true;

        this.loading = false;
      }
    }
  },
  computed: {
    showBoletoWarning() {
      return this.mustProvePayment(this.payable);
    }
  },
  mounted() {
    this.boleto = this.getBoleto();
  },
  watch: {
    payable() {
      this.boleto = this.getBoleto();
    }
  }
};
</script>

<template>
  <section class="pt-20 pb-20">
    <div class="success-content">
      <div class="success-icon"></div>

      <h2 v-if="boleto">SEU BOLETO ESTÁ PRONTO!</h2>
      <h2 v-else>SUA LIMPEZA FOI AGENDADA COM SUCESSO!</h2>
    </div>

    <div v-if="showBoletoWarning" class="boleto-warning">
      <h4>VOCÊ PRECISA ENVIAR O COMPROVANTE</h4>
      <p>
        Para que a limpeza não seja cancelada,
        <b class="pointer" @click="openSupport">clique aqui</b> e envie o comprovante de pagamento com até 48h úteis antes da limpeza.
      </p>
    </div>

    <boleto v-if="boleto" :boleto="boleto" />

    <div class="buttons">
      <router-link
        class="btn bg-pink mt-20"
        :to="{name: singularPayableType(), params: {id: payable.id}}"
      >{{buttonText()}}</router-link>

      <p v-if="payable.type === 'orders'">
        O profissional acaba de ser notificado sobre esta nova limpeza. O seu pagamento ficará retido no
        meio de pagamnento e só será enviado ao profissional após a limpeza. Caso o profissional cancele, você pode solicitar o reagendamento ou o reembolso.
      </p>

      <div v-if="this.payable.type === 'orders'" class="subscription">
        <div class="sub-loader" v-if="loading">
          <Loader />
          <p>Enviando solicitação para o nosso time de atendimento...</p>
        </div>

        <template v-else-if="success">
          <h4>Tudo certo! Nosso time de atendimento ao cliente recebeu a sua solicitação e em breve entrará em contato para acertar os detalhes e confirmar a sua assinatura.</h4>
        </template>

        <template v-else>
          <h4>
            Deixe suas limpezas programadas e viva a experiência do seu espaço sempre limpinho!
          </h4>

          <template v-if="error">
            <p>Ops. Não foi possível criar a solicitação com o nosso time de atenditmento. Tente novamente ou entre em contato se o problema persistir</p>
          </template>

          <div class="btn bg-purple btn-sub" @click="requestSubscription('Mensal')">
            <span>Quero repetir essa limpeza todo mês</span>
            <span class="discount">Economize até <b>R$ 72,00</b> em um ano</span>
          </div>

          <div class="btn bg-purple btn-sub" @click="requestSubscription('Quinzenal')">
            <span>Quero repetir essa limpeza a cada duas semanas</span>
            <span class="discount">Economize até <b>R$ 208,00</b> em um ano</span>
          </div>

          <div class="btn bg-purple btn-sub" @click="requestSubscription('Semanal')">
            <span>Quero repetir essa limpeza toda semana</span>
            <span class="discount">Economize até <b>R$ 520,00</b> em um ano</span>
          </div>

          <p v-if="payable.type === 'orders'">
            Com a assinatura Donamaid você não precisa mais se preocupar em agendar as suas limpezas. A sua limpeza com o seu profissional favorito é gerada automaticamente na frequência e horário da sua preferência.
          </p>

          <p v-if="payable.type === 'orders'">
            Essa super comodidade para o seu dia a dia ainda vem com ainda mais benefícios: um super desconto fixo para todas as suas limpezas de assinatura. Você não vai perder essa, né?
          </p>

          <p v-if="payable.type === 'orders'">
            Os planos não possuem fidelidade, então se precisar alterar o plano ou cancelar é super rápido e fácil.
          </p>
        </template>
      </div>
    </div>
    <FAQ :rules="payable.type === 'orders'" />
  </section>
</template>

<style scoped>
section {
  align-items: unset !important;
}

.subtitle {
  text-align: center;
  font-size: 14px;
  margin-bottom: 20px;
}

.boleto-warning {
  color: var(--pink);
  text-align: center;
}

.boleto-warning a {
  color: var(--pink) !important;
}

.boleto-warning h4 {
  margin: 0 0 10px 0;
}

.boleto-warning p {
  margin: 0;
}

h2 {
  text-align: center;
}

p {
  font-size: 14px;
  text-align: justify;
  text-align-last: center;
}

.buttons,
.wpp {
  max-width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.buttons .btn {
  margin-left: 0;
  margin-right: 0;
}

.wpp {
  flex-direction: column-reverse;
}

.wpp img {
  height: 18px;
  margin-bottom: 10px;
}

.success-content {
  display: flex;
  justify-content: center;
}

.thank-you-text {
  border: 1px dashed var(--pink);
  border-radius: 5px;
  margin-bottom: 25px;
  padding-left: 8px;
  padding-right: 8px;
}

.thank-you-text p {
  color: #7d014d;
}

.success-icon {
  background: url("/static/icon-success.svg") center no-repeat;
  min-width: 25px;
  height: 20px;
  margin-right: 10px;
}

h2 {
  font-size: 18px;
  margin-bottom: 0;
  margin-top: 0;
}

section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

ul li {
  padding: 3px 0;
}

.no-dots {
  list-style: none;
}

.no-dots img {
  transform: translateY(3px);
  margin-right: 3px;
}

.freshchat-icon {
  transform: translateY(5px);
}

.card {
  padding: 20px;
}

.subscription {
  position: relative;
  margin: 16px 0;
}

.btn-sub {
  display: flex;
  flex-direction: column;
}

.btn-sub > .discount {
  font-weight: 400;
}

.sub-loader {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.subscription:before {
  width: 200px;
  height: 2px;
  position: absolute;
  top: -8px;
  left: calc(50% - 100px);
  content: "";
  background: #603285;
}

@media (min-width: 668px) {
  p {
    text-align: center;
  }

  .subtitle {
    font-size: 16px;
  }

  .buttons,
  .wpp {
    flex-direction: column;
    margin: 0 auto;
  }

  .buttons .btn {
    margin-left: 5px;
    margin-right: 5px;
  }

  .wpp img {
    height: 18px;
    margin-bottom: 0;
  }

  .success-icon {
    min-width: 80px;
    height: 25px;
    margin-right: 0;
  }

  h2 {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Success.vue